export default {
  "userList.thead.userName": "用户名",
  "userList.thead.userNo": "用户编号",
  "userList.thead.email": "邮箱",
  "userList.thead.vipLevel": "VIP",
  "userList.thead.displayTags": "标签",
  "userList.thead.categoryTag": "用户分组",
  "userList.thead.channel": "推广渠道",
  "userList.thead.inviterUserno": "推荐人ID",
  "userList.thead.balanceAmount": "现金钱包余额",
  "userList.thead.bonusAmount": "奖金钱包余额",
  "userList.thead.totalDepositAmount": "存款",
  "userList.thead.totalWithdrawAmount": "取款",
  "userList.thead.depositWithdrawDiff": "存-取",
  "userList.thead.withdrawLimit": "流水限制",
  "userList.thead.status": "账号状态",
  "userList.thead.remark": "备注",
  "userList.thead.lastVisitTime": "最近访问",
  "userList.thead.registerIpNum": "IP注册数",
  "userList.thead.createTime": "创建时间",
  "userList.thead.createTimeFrom": "开始时间",
  "userList.thead.createTimeTo": "结束时间",
  "userList.thead.whatsapp": "Whatsapp",
  "userList.thead.registerIp": "注册IP",
  "userList.thead.xDayNoLogin": "多少天未登录",
  "userList.thead.referral": "来源",
  "userList.thead.lastLoginIp": "最近登录IP",
  "userList.thead.xDayDeposit": "最近几天有存款",
  "userList.thead.depositFlag": "是否有存款",
  "userList.title": "投注订单",
};
